export enum AnimationState {
  init = 0,
  added = 10,
  running = 20,
  stop = 25,
  finished = 30,
}
